class MutationObserverForIE10 {
  constructor(callBack) {
    this.callBack = callBack;
  }

  observe(element, options) {
    this.element = element;
    this.options = options;
    this.interval = setInterval(() => {
      const html = this.element.innerHTML;
      if (html !== this.oldHtml) {
        this.oldHtml = html;
        return this.callBack.call(this, ['changed']);
      }
    }, 200);
  }

  disconnect() {
    clearInterval(this.interval);
  }
}

const MutationObserver = window.MutationObserver || MutationObserverForIE10;

export default MutationObserver;
